/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Header from './header';
import '../styles/layout.scss';
import Nav from './nav';
import Footer from './footer';
import Burger from './burger';

const Layout = ({ isInHome, pageTitle, pageTitleColour=null, breadcrumb, breadcrumbPageTitle, children }) => {
  const [showNav, setShowNav] = useState(false);

  const toggleShowNav = () => {
    setShowNav(!showNav);
  }

  return (
    <>
      <Header
        pageTitle={pageTitle}
        pageTitleColour={pageTitleColour}
        isInHome={isInHome}
        isWhite={isInHome}
        breadcrumb={breadcrumb}
        breadcrumbPageTitle={breadcrumbPageTitle}
      />

      <main className={`${isInHome ? 'main--in-home' : ''}`}>{children}</main>

      <Footer isInHome={isInHome}/>
      <Nav
        show={showNav}
        setShowNav={setShowNav}
        isInHome={isInHome}
      />
      <Burger
        handleClick={toggleShowNav}
        light={showNav === false ? false : showNav}
        white={isInHome && showNav === false}
        isInHome={isInHome}
      />
    </>
  );
};

Layout.propTypes = {
  isInHome: PropTypes.bool,
  pageTitle: PropTypes.string,
  pageTitleColour: PropTypes.string,
  breadcrumbPageTitle: PropTypes.string,
  breadcrumb: PropTypes.array,
  children: PropTypes.node.isRequired
};

Layout.defaultProps = {
  isInHome: false,
  pageTitle: 'page title',
  pageTpageTitleColour: null,
  breadcrumbPageTitle: null,
  breadcrumb: null
};

export default Layout;
